import { useEffect, useState, useRef, memo, useMemo, useLayoutEffect } from 'react';
import api from 'services/api';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
import { addData } from 'store/secondaryVideoTabsDataSlice';
import { RootState } from 'store';
// import { getScrollPosition } from 'store/secondaryViewSlice';
import ReactMarkdown from 'react-markdown';
import { updateTabContent, getScrollPosition } from 'store/secondaryChannelVideoSlice';
interface Item {
  id: string;
  type: string;
  content: string;
}

function OverView({ secondaryViewData, currentVideoShot, secondaryViewSlice, selected, videoShots }: any) {
  const [OverViewList, setOverViewList] = useState<Item[]>([]);
  const dispatch = useDispatch();
  const scrolled = useRef(false);
  const keyId = secondaryViewData.channelId + secondaryViewData.hashId + currentVideoShot;
  const scrollRef = useRef<HTMLElement>();
  const videoShotId = useMemo(() => {
    if (!videoShots?.length || currentVideoShot == null) return null;
    return videoShots[currentVideoShot]?.shot_hash_id;
  }, [secondaryViewData.hashId, videoShots, currentVideoShot]);

  const overview = useSelector(
    (state: RootState) => state.secondaryViewTab.videos.find((video) => video.videoShotId === videoShotId)?.overview
  );

  useEffect(() => {
    if (!videoShotId) return;
    let isMounted = true;
    // Check if overview data already exists in Redux store
    if (overview) {
      setOverViewList(overview);
    } else {
      const fetchOverview = async () => {
        try {
          const endpoint =
            secondaryViewData.channelId !== 'home'
              ? `/api/channels/${secondaryViewData.channelId}/videos/${secondaryViewData.hashId}/shots/${videoShotId}/overview/`
              : `/api/videos/${secondaryViewData.hashId}/shots/${videoShotId}/overview/`;

          const res = await api.get(endpoint);

          if (isMounted) {
            setOverViewList(res.data.summary);
            dispatch(
              addData({ videoHashId: keyId, videoShotId: videoShotId, key: 'overview', data: res.data.summary })
            );
          }
        } catch (error) {
          console.error('Failed to fetch overview:', error);
        }
      };
      fetchOverview();
    }

    return () => {
      isMounted = false;
      setOverViewList([]);
      if (timer.current) {
        clearTimeout(timer.current); // Cleanup the timeout on unmount
      }
    };
  }, [videoShotId]);

  useLayoutEffect(() => {
    const defaultScrollTop = getScrollPosition(
      secondaryViewSlice,
      secondaryViewData.channelId,
      secondaryViewData.hashId,
      'overview'
    );

    if (scrollRef.current && defaultScrollTop) {
      scrollRef.current.classList.add(`opacity-0`);
    } else if (scrollRef.current && defaultScrollTop === undefined) {
      scrollRef.current.scrollTop = 0;
    }

    setTimeout(() => {
      if (scrollRef && scrollRef.current && defaultScrollTop) {
        scrollRef.current.classList.add(`transition-opacity`, `duration-200`, `ease-in-out`, `opacity-100`);
        scrollRef.current.scrollTop = defaultScrollTop;
      }
    }, 100);
  }, [secondaryViewData.hashId, selected]);

  const dispatchUpdatedContent = (currentPosition: number) => {
    if (currentPosition !== undefined) {
      dispatch(
        updateTabContent({
          channelHashId: secondaryViewData.channelId,
          videoHashId: secondaryViewData.hashId,
          data: {
            overview: { scrollPosition: currentPosition }
          }
        })
      );
    }
  };

  const timer = useRef<NodeJS.Timeout | null>(null); // Explicitly type the ref
  const handleScroll = () => {
    scrolled.current = true;
    if (timer.current) {
      clearTimeout(timer.current);
    }
    // Set a timeout to detect when scrolling has stopped
    timer.current = setTimeout(() => {
      if (scrollRef.current) {
        console.log('saving scroll overview', secondaryViewData.channelId, scrollRef.current.scrollTop);
        dispatchUpdatedContent(scrollRef.current.scrollTop);
      }
    }, 200); // 200ms del
  };

  return (
    <div className={`absolute w-full flex flex-col flex-1 top-0 right-0 left-0 bottom-0 overflow-y-hidden text-sm`}>
      <PerfectScrollbar
        containerRef={(el) => (scrollRef.current = el)}
        style={{ maxHeight: `100%` }}
        options={{ suppressScrollY: false, suppressScrollX: true }}
        onScrollY={handleScroll}
      >
        <div className="px-4">
          <div className="prose custom-prose text-black">
            {OverViewList.map((item: any) => (
              <ReactMarkdown key={item.id}>{item.content}</ReactMarkdown>
            ))}
          </div>

          <div className="h-4 w-full"></div>
        </div>
      </PerfectScrollbar>
    </div>
  );
}

export default memo(OverView);
